import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

import './index.less';

const Footer = () => (
  <footer className="footer">
    <Grid>
      <Row>
        <Col sm={3}>
        </Col>
        <Col sm={6}>
          <p className="text-center">
            © Пласт НСОУ. КБ УПЮ. 2018. |{' '}
            <a href="mailto:vasylshvv@gmail.com">Контакти адміністраторів</a>
          </p>
        </Col>
      </Row>
    </Grid>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Main/Footer.js